import { render, staticRenderFns } from "./CurrentBillingManagementDetails.vue?vue&type=template&id=c1ba5b12&scoped=true"
import script from "./CurrentBillingManagementDetails.vue?vue&type=script&lang=js"
export * from "./CurrentBillingManagementDetails.vue?vue&type=script&lang=js"
import style0 from "./CurrentBillingManagementDetails.vue?vue&type=style&index=0&id=c1ba5b12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ba5b12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
